import { useEffect, useState } from "react";

const navItems = [
  { label: "实时快报", href: "#live" },
  { label: "热门瓜", href: "#hot" },
  { label: "主题分类", href: "#topic" },
  { label: "深度专题", href: "#detail" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50/80 backdrop-blur"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 flex items-center justify-between" aria-label="主导航">
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer shrink-0">
          <span className="w-9 h-9 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center font-heading text-xl leading-none">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl text-foreground-950 tracking-wide">瓜田速递</span>
            <span className="text-[10px] text-foreground-500 tracking-[0.2em] mt-0.5">LIVE FEED</span>
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className="px-3 py-2 text-sm text-foreground-700 rounded-md hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#contact"
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-notification-3-line text-base w-5 h-5 flex items-center justify-center" aria-hidden="true"></i>
            订阅快讯
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50">
          <ul className="px-4 py-3 flex flex-col">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="block px-3 py-3 text-sm text-foreground-800 rounded-md hover:bg-background-100 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li className="pt-2">
              <a
                href="#contact"
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-center gap-2 px-3 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
              >
                <i className="ri-notification-3-line text-base w-5 h-5 flex items-center justify-center" aria-hidden="true"></i>
                订阅快讯
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}